import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DeviceService } from 'app/services/models/device.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-expiry-certificate-device',
  templateUrl: './expiry-certificate-device.component.html',
  styleUrls: ['./expiry-certificate-device.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ExpiryCertificateDeviceComponent implements OnInit {
  @Input() data: { title?:string, content?: string, mail: string };
  form: FormGroup;

  quillConfig = {
    toolbar: {
      container: [
        [{ 'font': [] }],
        ['bold', 'italic', 'underline', 'strike'],
        [{ 'size': ['small', 'medium'] }],
      ]
    }
  }

  constructor(
    public activeModal: NgbActiveModal,
    public deviceSerivce: DeviceService,
    private fb: FormBuilder,
    private toastrService:ToastrService
  ) { }

  ngOnInit() {
    this.form = this.fb.group({
      mail: ['', Validators.required],
      title: ['', Validators.required],
      description: ['', Validators.required]
    });
    if(this.data.mail){
      this.form.patchValue({
        mail:this.data.mail,
      })
    }
    if(this.data.content){
      this.form.patchValue({
        description:this.data.content
      })
    }
    if(this.data.title){
      this.form.patchValue({
        title:this.data.title
      });
    }
  }

  closeModal() {
    this.activeModal.close(false);
  }

  async onSubmit() {
    if (this.form.valid) {
      console.log(this.form.value);
      const form = this.form.value;
      const data = await this.deviceSerivce.sendExpiryDeivce(form.mail,form.title,form.description);
      if(data.status == true){
        this.toastrService.success(data.message);
        this.closeModal();
      }else{
        this.toastrService.error(data.message);
      }
    }
  }
}
